var map = {
	"./2018-03-04/whats-new.html": 2231,
	"./2018-04-12/whats-new.html": 2232,
	"./2018-04-24/whats-new.html": 2233,
	"./2018-05-23/whats-new.html": 2234,
	"./2018-05-31/whats-new.html": 2235,
	"./2018-07-04/whats-new.html": 2236,
	"./2018-07-19/whats-new.html": 2237,
	"./2018-11-20/whats-new.html": 2238,
	"./2019-04-04/whats-new.html": 2239,
	"./2020-01-21/whats-new.html": 2240,
	"./2020-07-18/whats-new.html": 2241,
	"./2021-06-10/whats-new.html": 2242,
	"./2021-07-26/whats-new.html": 2243,
	"./2021-08-26/whats-new.html": 2244,
	"./2021-12-07/whats-new.html": 2245,
	"./2022-06-03/whats-new.html": 2246,
	"./2022-09-08/whats-new.html": 2247,
	"./2023-01-01/whats-new.html": 2248,
	"./2023-06-14/whats-new.html": 2249,
	"./2024-10-31/whats-new.html": 2250,
	"./2024-12-12/whats-new.html": 2251
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2230;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 2230
// module chunks = 0